import { ROUTE_PATH as WHITELIST_GROUPS_PAGE_PATH } from '@/features/parkingWhitelistGroupsPage/consts';

export const ROUTE_PATH = `${WHITELIST_GROUPS_PAGE_PATH}/:groupId`;

export const FEATURE_NAME = 'parkingWhitelistGroupDetailsPage';
